import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const SuiteNavBar = ({ currentPage }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="bg-sand-100 text-ink-900 border-b-4 border-coral-300">
      <div className="max-w-6xl mx-auto px-2 sm:px-4">
        <div className="flex justify-between items-center h-16 sm:h-20 md:h-24">
          
          {/* Logo */}
          <div className="flex items-center">
            <div 
              onClick={() => navigate('/dashboard')} 
              className="cursor-pointer hover:opacity-80 transition-opacity"
            >
              <img 
                src="/images/teaich-logo.png" 
                alt="TeAIch" 
                className="h-12 sm:h-16 md:h-20 lg:h-24 w-auto" 
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex space-x-4 xl:space-x-8">
            <button 
              onClick={() => navigate('/dashboard')} 
              className={`text-sm xl:text-lg py-2 px-2 xl:px-3 rounded transition-colors font-medium text-coral-500 hover:text-coral-600 ${
                currentPage === 'dashboard' ? 'opacity-60' : ''
              }`}
            >
              Main Menu
            </button>
            <button 
              onClick={() => navigate('/assess')} 
              className={`text-sm xl:text-lg py-2 px-2 xl:px-3 rounded transition-colors font-medium text-coral-500 hover:text-coral-600 ${
                currentPage === 'assess' ? 'opacity-60' : ''
              }`}
            >
              Assess
            </button>
            <button 
              onClick={() => navigate('/planner')} 
              className={`text-sm xl:text-lg py-2 px-2 xl:px-3 rounded transition-colors font-medium text-coral-500 hover:text-coral-600 ${
                currentPage === 'planner' ? 'opacity-60' : ''
              }`}
            >
              Planner
            </button>
            <button 
              onClick={() => navigate('/insights')} 
              className={`text-sm xl:text-lg py-2 px-2 xl:px-3 rounded transition-colors font-medium text-coral-500 hover:text-coral-600 ${
                currentPage === 'insights' ? 'opacity-60' : ''
              }`}
            >
              Insights
            </button>
            <button 
              onClick={() => navigate('/my-info')} 
              className={`text-sm xl:text-lg py-2 px-2 xl:px-3 rounded transition-colors font-medium text-coral-500 hover:text-coral-600 ${
                currentPage === 'my-info' ? 'opacity-60' : ''
              }`}
              
            >
              Account
            </button>
            <button 
              onClick={handleLogout} 
              className="text-sm xl:text-lg py-2 px-2 xl:px-3 rounded transition-colors font-medium text-coral-500 hover:text-coral-600 flex items-center"
            >
              <LogOut className="w-4 h-4 xl:w-6 xl:h-6 mr-1 xl:mr-2" />
              Logout
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-md text-coral-500 hover:text-coral-600"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-coral-400 py-2">
            <div className="flex flex-col space-y-2">
              <button 
                onClick={() => { navigate('/dashboard'); setIsMenuOpen(false); }} 
                className={`text-left text-base py-2 px-4 rounded transition-colors font-medium hover:bg-coral-500 hover:text-white ${
                  currentPage === 'dashboard' ? 'bg-coral-500 text-white' : 'text-coral-500'
                }`}
              >
                Main Menu
              </button>
              <button 
                onClick={() => { navigate('/assess'); setIsMenuOpen(false); }} 
                className={`text-left text-base py-2 px-4 rounded transition-colors font-medium hover:bg-coral-500 hover:text-white ${
                  currentPage === 'assess' ? 'bg-coral-500 text-white' : 'text-coral-500'
                }`}
              >
                Assess
              </button>
              <button 
                onClick={() => { navigate('/planner'); setIsMenuOpen(false); }} 
                className={`text-left text-base py-2 px-4 rounded transition-colors font-medium hover:bg-coral-500 hover:text-white ${
                  currentPage === 'planner' ? 'bg-coral-500 text-white' : 'text-coral-500'
                }`}
              >
                Planner
              </button>
              <button 
                onClick={() => { navigate('/insights'); setIsMenuOpen(false); }} 
                className={`text-left text-base py-2 px-4 rounded transition-colors font-medium hover:bg-coral-500 hover:text-white ${
                  currentPage === 'insights' ? 'bg-coral-500 text-white' : 'text-coral-500'
                }`}
              >
                Insights
              </button>
              <button 
                onClick={() => { navigate('/my-info'); setIsMenuOpen(false); }} 
                className={`text-left text-base py-2 px-4 rounded transition-colors font-medium hover:bg-coral-500 hover:text-white ${
                  currentPage === 'my-info' ? 'bg-coral-500 text-white' : 'text-coral-500'
                }`}
              >
                Account Management
              </button>
              <button 
                onClick={() => { handleLogout(); setIsMenuOpen(false); }} 
                className="text-left text-base py-2 px-4 rounded transition-colors font-medium text-coral-500 hover:bg-coral-500 hover:text-white flex items-center"
              >
                <LogOut className="w-5 h-5 mr-2" />
                Logout
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default SuiteNavBar;